export const USER_DATA = {
  About: {
    name: 'Huzaifa Anjum',
    occupation: 'FULL STACK DEVELOPER & DYNAMICS 365 CUSTOMIZER',
    details: [
      {
        title: 'Age',
        value: 24
      },
      {
        title: 'Address',
        value: 'Mumbai Suburban district, Maharashtra, India.'
      },
      {
        title: 'Email',
        value: 'huzaifafcrit@gmail.com'
      },
      {
        title: 'Industry',
        value: 'Information Technology'
      }
    ]
  },
  interests: {
    title: 'Interests',
    value: [
      {
        name: 'Music',
        icon: 'headset',
        color: 'royalblue'
      },
      {
        name: 'Gaming',
        icon: 'games',
        color: 'crimson'
      },
      {
        name: 'Reading',
        icon: 'book',
        color: 'goldenrod'
      },
      {
        name: 'Sports',
        icon: 'sports_soccer',
        color: 'forestgreen'
      },
      {
        name: 'Travel',
        icon: 'flight_takeoff',
        color: 'purple'
      },
      {
        name: 'Photography',
        icon: 'photo_camera',
        color: 'grey'
      }
    ]
  }
};


export const TIMELINE_DATA = [
  {
    id: 0,
    duration: 'September 2023 - Present',
    title: 'MACS Graduate Student at Concordia University, Canada',
    logoUrl: '../../../../assets/img/logos/conlogo.png',
    description: "Ever since discovering the realm of computer science following my high school education, I've been on a passionate journey of self-improvement and exploration of technology. This relentless pursuit of knowledge has equipped me with a diverse skill set and an unwavering commitment to innovation. My journey into the tech field began post-high school, prompting an ardent dedication to daily improvement. Through roles at CitiusTech and Willis Towers Watson, I've delved into software development, healthcare systems, and agile methodologies, all while adhering to software principles like OOPS, SOLID, and more. Crafting solutions that leverage AI technology to enhance medical imaging processes at CitiusTech encapsulated the impactful work that drives my passion for problem-solving. My first semester in the master's program at Concordia University has provided me with practical experience in essential technologies, including Containerization, Cassandra database management, Software Measurement methodologies, problem-solving, Python and Java programming languages. Looking forward, I am excited about the upcoming coursework in areas such as Human-Computer Interaction (HCI), Data Structures, Machine Learning (ML), and Artificial Intelligence (AI). These studies will further augment my skill set and align seamlessly with my practical expertise developed as a Senior Software Developer.",
    footer: null,
    link: {
      name: 'LinkedIn',
      displayName: 'Link to LinkedIn Profile',
      value: 'https:\/\/in.linkedin.com\/in\/huzaifa-anjum-90b117133?trk=public_profile_browsemap_mini-profile_title'
    }
  },
  {
    id: 1,
    duration: 'December 2021 - August 2023',
    title: 'Senior Full Stack Developer at CitiusTech',
    logoUrl: '../../../../assets/img/logos/citiustech.jpg',
    description: 'Developing and delivering best in class healthcare technology solution(s). Working with client: "Merge Healthcare" to develope a Tumor Tracking Universal Viewer capable of understanding DICOM information and predicting tumor and its growth using AI. Delivering high quality code by adhering to software development principles (SOLID’s principle, OOPs Principle) using Design Patterns (Strategy Pattern, Factory pattern). Performing code reviews and improving UI and usability of application.',
    footer: {
      licon: 'fa-building',
      lname: '1 year 0 month',
      lvalue: '',
      ricon: 'fa-certificate',
      rname: 'Certificates : ',
      rvalue: '05'
    },
    link: {
      name: 'LinkedIn',
      displayName: 'Link to LinkedIn Profile',
      value: 'https:\/\/in.linkedin.com\/in\/huzaifa-anjum-90b117133?trk=public_profile_browsemap_mini-profile_title'
    }
  },
  {
    id: 2,
    duration: '10th February 2022 - 19th February 2022',
    title: 'UI/UX consultant at Homesfy Realty Pvt Ltd.',
    logoUrl: '../../../../assets/img/logos/homesify.jpg',
    description: 'Provided UI/UX consultancy to Homesfy Realty Pvt Ltd. for their project mymagnet.io.',
    footer: {
      licon: 'fa-building',
      lname: '1 week',
      lvalue: '',
      ricon: 'fa-certificate',
      rname: 'Certificates : ',
      rvalue: '01'
    },
    link: {
      name: 'My Magnet',
      displayName: 'Link to mymagnet.io',
      value: 'https:\/\/mymagnet.io'
    }
  },
  {
    id: 3,
    duration: 'July 2019 - November 2021',
    title: 'Full Stack Developer & Dynamics 365 Customizer at Willis Towers Watson',
    logoUrl: '../../../../assets/img/logos/wtw.png',
    description: 'Developed and delivered production ready, enterprise grade applications which help the organization by reducing effort, perform more efficiently and save time & money. Continuously added new and valuable features and functionality to the application in each sprint. Monitored and improved the performance of applications (reduced an application’s data loading time from 5-10sec to 0.5-1sec). Improved application accessibility (Application could be used with keyboard or mouse or both) which help in reducing time and effort to complete a business process. Worked on the following technologies, languages and tools: Angular, Asp.Net Core, Ms Sql Server, Cosmos DB, Azure Functions, Azure Cloud, Power BI, HTML, CSS, Bootstrap, Sass, Scss and more. Also, gained experience on working with Microsoft Graph Api. Delivered high quality code by adhering to software development principles (SOLID’s principle, ONION Principle), used Design Patterns (Strategy Pattern) and Repository Pattern (for abstracting data logic). Developed robust api’s by following best practices and implemented unit tests. Worked with Dapper and Entity Framework Core. Gained experience on CI/CD using Azure DevOps. Worked with Git for versioning and tracking code changes. Creating and managing NuGet Packages and Angular libraries. Also gained experience of working as a D365 CRM Customizer.',
    footer: {
      licon: 'fa-building',
      lname: '1 year 1 month',
      lvalue: '',
      ricon: 'fa-certificate',
      rname: 'Certificates : ',
      rvalue: '14'
    },
    link: {
      name: 'LinkedIn',
      displayName: 'Link to LinkedIn Profile',
      value: 'https:\/\/in.linkedin.com\/in\/huzaifa-anjum-90b117133?trk=public_profile_browsemap_mini-profile_title'
    }
  },
  {
    id: 4,
    duration: 'January 2019 - January 2019',
    title: 'Internship at Reliance Industries, developed a MEAN stack application',
    logoUrl: '../../../../assets/img/logos/reliance.jpg',
    description: 'This was a personal project which I was asked to create by my mentor during the 1-month internship period at Reliance Industries Pvt Ltd. The goal of the project was to develop a web application to help project managers in managing employees and projects. The application uses a 3-Tier architecture i.e. Angular (Front-end), Express Server (Server), MongoDB (Database). The application was developed using front-end technologies: Angular7, Typescript, html, CSS, bootstrap4. back-end database: MongoDB and Middleware (Api): Express Server, NodeJS. The user data transfer was done by using CRUD operations. Authentication was implemented using JWT (Json Web Token). The project User Interface was responsive in nature i.e. can be used on mobile as well. The project consisted of following components: home, login, register, dashboard, employee, project, report. The application was also checked on android by creating a basic app which took URL generated by NgRok software as input and loaded the application as a web View on android smartphone. Form validation was implemented using ngModel properties like ng-untouched, ng-pristine etc. and Javascript.',
    footer: {
      licon: 'fa-tools',
      lname: 'Projects : ',
      lvalue: '01',
      ricon: 'fa-certificate',
      rname: 'Certificates : ',
      rvalue: '01'
    },
    link: {
      name: 'Github',
      displayName: 'Link to Github Repository',
      value: 'https:\/\/github.com\/huzaifaanjum\/ProjectManagementSystem.git'
    }
  },
  {
    id: 5,
    duration: 'June 2015 - June 2019',
    title: 'Bachelor of Engineering - BE, Information Technology from Mumbai University',
    logoUrl: '../../../../assets/img/logos/mu.jpg',
    description: 'Graduated with a CGPA of 8.9 in Bachelor of Engineering - BE, Information Technology from Mumbai University. During the graduation period I got to work on several Projects and Mini-Projects, organized a fest, attended and conducted technical workshops for CSI and won several football tournaments.',
    footer: {
      licon: 'fa-tools',
      lname: 'Projects : ',
      lvalue: '04',
      ricon: 'fa-certificate',
      rname: 'Certificates : ',
      rvalue: '06'
    }
  }
  // ,
  // {
  //   id: 5,
  //   duration: 'June 2014 - June 2015',
  //   title: 'Higher Secondary Education from Central Board of Secondary Education (CBSE)',
  //   logoUrl: '../../../../assets/img/logos/ryan.png',
  //   description: 'Completed Higher Secondary Education from Central Board of Secondary Education (CBSE). Explored various subjects available in the field of science such as Physics, Chemistry, Mathematics and Computers. Learned to code in C and C++.',
  //   footer: null
  // }
];

export const CAROUSEL_IMAGES_DETAILS = [
  {
    id: 3,
    title: 'Html Css and JavaScript',
    category: 'mfst',
    src: '../../../../assets/img/certificate/mfst/htmlcssjs.png'
  },
  {
    id: 0,
    title: 'Prompt Engineering for ChatGPT',
    category: 'Coursera',
    src: '../../../../assets/img/certificate/general/promptEngCoursera.png'
  },
  {
    id: 1,
    title: 'SQL',
    category: 'HackerRank',
    src: '../../../../assets/img/certificate/general/sql.png'
  },
  {
    id: 13,
    title: 'Angular Cli',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/Angular - Angular CLI course completion certificate-1.png'
  },
  {
    id: 5,
    title: 'Azure Fundamentals',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/mfst/rsz_azure_fundamentals_certificate-1.png'
  },
  {
    id: 14,
    title: 'Angular forms',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/Angular - Angular Forms course completion certificate-1.png'
  },
  {
    id: 2,
    title: 'Angular Getting Started',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/Angular - Getting Started course completion certificate-1.png'
  },
  {
    id: 7,
    title: 'dotnet core 3.1',
    category: 'udemy',
    src: '../../../../assets/img/certificate/general/rsz_1rsz_1rsz_1dotnet_core31_certificate.png'
  },
  {
    id: 6,
    title: 'Angular HTTP Communication',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/Angular HTTP Communication-1.png'
  },
  {
    id: 4,
    title: 'Angular Big Picture',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/Angular - The Big Picture course completion certificate-1.png'
  },
  {
    id: 8,
    title: 'Continuous Delivery and DevOps with Azure DevOps',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/Continuous Delivery and DevOps with Azure DevOps-1.png'
  },
  {
    id: 9,
    title: 'Microsoft Dynamics 365 Customer Engagement (CRM) - Customization and Configuration',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/Microsoft Dynamics 365 Customer Engagement (CRM) - Customization and Configuration-1.png'
  },
  {
    id: 10,
    title: 'Microsoft Dynamics 365 Customer Engagement (CRM) - Getting Started',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/Microsoft Dynamics 365 Customer Engagement (CRM) - Getting Started-1.png'
  },
  {
    id: 11,
    title: 'Securing Angular Apps with OpenID Connect and OAuth 2',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/Securing Angular Apps with OpenID Connect and OAuth 2-1.png'
  },
  {
    id: 12,
    title: 'The 35 Things Everyone Needs to Know About Dynamics CRM',
    category: 'pluralsight',
    src: '../../../../assets/img/certificate/AngularCertificate/The 35 Things Everyone Needs to Know About Dynamics CRM-1.png'
  },

];


export const PROJECTS = [
  {
    id: 1,
    display: false,
    title: 'Huzaifa Anjum',
    imgSrc: '../../../../assets/img/projects/portfolio.png',
    year: '2020',
    shortDescription: 'Portfolio',
    technologies: ['Angular', 'TypeScript', 'Firebase', 'Azure DevOps', 'Angular Material', 'Bootstrap', 'Html 5', 'Css 3', 'Scss'],
    description: 'Developed and hosted my own portfolio site. This was a personal project which speaks volumes about my journey as a web application developer and a person. It was a fun and thrilling ride working on this webapp. The site in demonstrates my creativity in terms of UI/UX. The site is optimized for delivering a great overall user experience. The user interface is responsive in nature i.e. site can be viewed on devices of different resolutions thanks to bootstrap4, css3 and CSS3 media queries. The site is easily maintainable thanks to Angular and Firebase. CI/CD through Azure DevOps has eased the deployment task. Use of Google Tag Manager and Google Analytics for monitoring site traffic has played a crucial part in understanding the behavior of users visiting the site.'
  },
  {
    id: 2,
    display: true,
    title: 'Dynamics CRM',
    class: 'my-4',
    imgSrc: '../../../../assets/img/projects/crm.png',
    year: '2020',
    shortDescription: 'CRM System',
    technologies: [],
    description: 'Have a short experience as a Dynamic CRM customizer. Creating/Editing forms, creating buisness rules and process flows and automated workflows, creating cascaded dropdowns, editing system setting, creating dashboards, fullfilling requirements using javascript which are not available out of box. Creating and editing new security roles.'
  },
  {
    id: 3,
    display: false,
    title: 'EMS',
    imgSrc: '../../../../assets/img/projects/ems.png',
    year: '2019',
    shortDescription: 'Expense Management',
    technologies: ['Asp.net Webforms', 'ADO.Net', 'MsSqlServer', 'C#', 'Html5', 'Css3', 'Bootstrap 4'],
    description: 'Developed a web application for managing expenses of employees travelling abroad for work. The site was developed to facilitate the reimbursement process. The application was developed in a team of two, in the time period of a one week. The employees could select the time period of their travel and add expenses for each day along with the scanned images of bills. After uploading the details a requests was raised to the manager for approval. Once approved by the line manager, an auto generated mail was sent to the finance team requesting for reimbursement for the employee with the expense details. If the request was not approved a mail was generated to the employee providing the reason (provided by manager) and suggested changes. THe employee can then edit the expense information accordingly and submit for around approval. The dashboard provided several statistical information such as request status, expenditure areas, payment done using and more.'
  },
  {
    id: 4,
    display: true,
    title: 'RilPMS',
    imgSrc: '../../../../assets/img/projects/rilpms.png',
    year: '2019',
    shortDescription: 'Project Management',
    technologies: ['Angular', 'Express', 'Node.js', 'MongoDB', 'JWT', 'GitLab', 'Bootstrap 4', 'Html 5', 'Css 3', 'NgRok'],
    description: 'This was a personal project which I was asked to create by my mentor during the 1-month internship period at Reliance Industries Pvt Ltd. The goal of the project was to develop a web application to help project managers in managing employees and projects. The application uses a 3-Tier architecture i.e. Angular (Front-end), Express Server (Server), MongoDB (Database). The application was developed using front-end technologies: Angular7, Typescript, html, CSS, bootstrap4. back-end database: MongoDB and Middleware (Api): Express Server, NodeJS. The user data transfer was done by using CRUD operations. Authentication was implemented using JWT (Json Web Token). The project User Interface was responsive in nature i.e. can be used on mobile as well. The project consisted of following components: home, login, register, dashboard, employee, project, report. The application was also checked on android by creating a basic app which took URL generated by NgRok software as input and loaded the application as a web View on android smartphone. Form validation was implemented using ngModel properties like ng-untouched, ng-pristine etc. and Javascript.'
  },
  {
    id: 5,
    display: true,
    title: 'BuyIt',
    imgSrc: '../../../../assets/img/projects/buyit.png',
    year: '2018',
    shortDescription: 'E-Commerce',
    technologies: ['Php', 'Ajax', 'JavaScript', 'Xampp', '000webhost', 'My Sql', 'Bootstrap 4', 'Html 5', 'Css 3'],
    description: 'In this project we created a fully functional e-commerce clothing website where a user could browse and place orders from the various available products. The website was developed in modules. Few of the modules were: Authentication module (registration, email verification, user login), Products dashboard module (Display latest deals, announcement, contact information), Product details Module (Display product specification, images. Add product to Wishlist/Cart based on available quantity), Wishlist Module, Cart Module, Check Out Module, Order Tracking Module. I had designed and implemented the frontend and business logic of the website. The website’s user interface was made responsive in nature i.e. it could be viewed on devices of different resolutions using Bootstrap4 and CSS3 media queries. For front end I had used HTML, CSS3, Bootstrap4, Javascript and Ajax. For database we used MySQL database. The business logic was implemented in Php. For email verification we used PhpMailer. We had also added a google map in the website contact us section. The website was first developed locally using XAMPP Server and later hosted on 000webhost.com.'
  },
  {
    id: 6,
    display: false,
    title: 'Fcrit',
    imgSrc: '../../../../assets/img/projects/college.png',
    year: '2018',
    shortDescription: 'College Website',
    technologies: ['Php', 'Ajax', 'JavaScript', 'Xampp', 'My Sql', 'Html 5', 'Css 3'],
    description: 'Contributed towards development of college website. Created forms to record data. Added styling to the webpages.'
  },
];


export const SKILLS = {
  summary: 'Technology Enthusiast, willing to learn and grow, more and more, each day. Full Stack Developer (Angular 9, .Net Core 3.1, MsSqlServer, CosmosDB, Azure) at CitiusTech. Fundamental knowledge of Microsoft Azure DevOps and Microsoft Azure Cloud.',
  skills: [
    {
      type: 'TechnicalSkills',
      skill: [
        {
          name: 'HTML, CSS, JavaScript',
          value: 90
        },
        {
          name: 'ASP.Net Core',
          value: 85
        },
        {
          name: 'Ms Sql, Cosmos DB, Mongo DB',
          value: 83
        }
      ]
    },
    {
      type: 'softskills',
      skill: [
        {
          name: 'Communication & Teamwork',
          value: 95
        },
        {
          name: 'Problem-solving',
          value: 90
        },
        {
          name: 'Time management',
          value: 90
        }
      ]
    }
  ]
};
